export default function PullToRefreshIndicator({ pulling, pullDistance, threshold }) {
  if (!pulling || pullDistance < 5) return null
  const ready = pullDistance >= threshold
  return (
    <div
      className="pull-indicator"
      style={{ top: `${Math.min(pullDistance, 120)}px`, opacity: Math.min(pullDistance / 40, 1) }}
    >
      <div
        className={`w-10 h-10 rounded-full flex items-center justify-center shadow-lg transition-colors ${ready ? 'bg-ocean-500' : 'bg-white border border-slate-200'}`}
      >
        <ion-icon
          name="arrow-down-outline"
          style={{
            fontSize: 20,
            color: ready ? 'white' : '#64748b',
            transform: `rotate(${ready ? 180 : Math.min((pullDistance / threshold) * 180, 180)}deg)`,
          }}
        ></ion-icon>
      </div>
    </div>
  )
}
